<template>
  <div class="opera-center" style="background-color: #f7f8fa">
    <div class="head clearfix" style="background: url('./static/images/centerBg.png') center;">
      <router-link to="/opera/huanqiuCenterInfo?redirect=/opera/centerHuanQiu">
        <div class="textImg">
          <div class="pic">
            <img :src="perInfo.pic" v-if='!!perInfo.pic'>
            <img v-else src="../../assets/images/tx.png">
          </div>
          <div class="text">
            <p class="name">{{ perInfo.name }}</p>
          </div>
          <i class="iconfont icon-you"></i>
        </div>
      </router-link>
    </div>
    <ul class="setOption">
      <mt-cell title="楼栋绑定"
               v-if="mihotelBinding" to="/opera/bindBuildingHuanQiu" is-link></mt-cell>
      <mt-cell title="日志查看" to="/opera/logRecordHuanQiu" is-link></mt-cell>
      <mt-cell title="版本信息" to="/opera/versionDetailHuanQiu" is-link></mt-cell>
      <mt-cell title="参数配置" to="/opera/settingHuanQiu" is-link></mt-cell>
    </ul>
    <div class="btn" @click="loginOut">{{ $t('logout') }}</div>
    <foot-nav sta='3'></foot-nav>
  </div>
</template>
<script>
import footNav from "../operaCommon/huanQiufootNav";
import {Toast, MessageBox} from "mint-ui";
import {shareApp} from "../../assets/js/share.js";

export default {
  data() {
    return {
      perInfo: {},
      bMihotel: false,
      mihotelBinding: localStorage.getItem('mihotelBinding') == 'yes',
      mihotelLogSee: localStorage.getItem('mihotelLogSee') == 'yes',
    };
  },
  mounted() {
    this.bMihotel = this.$isMihotel;
    this.$http.get("/mobilepmsapi/sys/getUserInfo").then(res => {
      if (res.data.result == 0) {
        this.perInfo = res.data.retVal;
      }
    });
  },
  methods: {
    share() {
      shareApp();
    },
    loginOut() {
      var that = this;
      MessageBox.confirm(this.$t("MessageBox_areYouSure"))
        .then(action => {
          localStorage.removeItem("JWT_TOKEN");
          if (that.$isApp) {
            var A = plus.webview.getLaunchWebview();
            A.evalJS("loginOut(true)");
            return;
          }
          location.reload();
        })
        .catch(action => {
        });
    },
    openOutUrl() {
      if (this.$isApp) {
        var A = plus.webview.getLaunchWebview();
        A.evalJS('openUrl("https://www.sojump.hk/jq/15446001.aspx")');
      } else {
        MessageBox.confirm(this.$t("center_message"))
          .then(action => {
            var url = "https://www.sojump.hk/jq/15446001.aspx";
            location.href = url;
          })
          .catch(action => {
          });
      }
    },
    msg(msg) {
      Toast({message: msg, position: "bottom", duration: 3000});
    }
  },
  filters: {},
  components: {
    footNav
  }
};
</script>
<style lang='less' scoped>
.opera-center {
  .head {
    background-size: cover;
    height: 150px;
    overflow: hidden;

    .textImg {
      color: #fff;
      height: 60px;
      margin: 39px 0 0 35px;

      .pic {
        float: left;
        width: 60px;
        height: 60px;
        border-radius: 50%;
        overflow: hidden;
        /*background-color: blue;*/

        img {
          width: 100%;
          height: 100%;
        }
      }

      .text {
        float: left;
        margin-left: 20px;
        margin-top: 18px;

        .name {
          font-size: 20px;
          line-height: 25px;
        }

        .roles {
          font-size: 12px;
          line-height: 35px;
          transform: scale(0.83);
          transform-origin: left;
        }
      }

      .icon-you {
        float: right;
        margin-top: 25px;
        margin-right: 10px;
        color: #979797;
        font-size: 14px;
      }
    }
  }

  .setOption .mint-cell {
    height: 50px;
  }

  .btn {
    height: 50px;
    text-align: center;
    color: #333;
    width: 100%;
    margin: 0 auto;
    font-size: 14px;
    line-height: 50px;
    margin-top: 30px;
    background: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// centerHuanQiu.vue?0ddb4c7a